<template>
    <component :is="template">
        <v-container>
            <v-row>
                <v-col>
                    <div class="contents-area">
                        <div class="contents-area__inner">
                            <div class="tit-wrap tit-wrap--unberline">
                                <v-row align="center">
                                    <v-col cols="12" md="">
                                        <h2 class="tit">쿠폰 교환소</h2>
                                    </v-col>
                                    <v-col cols="12" md="auto">
                                        <v-text-field v-model="searchValue" name="searchValue" type="search" autocomplete="off" hide-details outlined placeholder="쿠폰 검색" class="w-100 w-md-260px" @keydown.enter="()=>$router.push(`giftcards/search?search=${searchValue}`)">
                                            <template v-slot:append>
                                                <v-icon v-show="searchValue" size="28" class="mr-1" @click="searchValue = null">mdi-close</v-icon>
                                                <v-icon size="28" @click="()=>$router.push(`giftcards/search?search=${searchValue}`)">mdi-magnify</v-icon>
                                            </template>
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                            </div>

                            <div class="font-size-14 font-size-md-16 grey--text text--garken-3 mt-md-n20px mb-20px mb-md-22px">
                                <p>* 교환소 내 모든 상품은 나누리 캐시로 교환 할 수 있는 상품입니다. 캐시 외에 구입 불가 합니다.</p>
                                <p>* 본인인증을 진행한 후 30분 동안 교환소 이용이 가능합니다.</p>
                                <p>* 교환 전 본인인증을 진행해 주세요.</p>
                            </div>

                            <!-- 쿠폰 카테고리 -->
                            <giftcard-navi :categories="categories" @setCategory="setCategory"/>

                            <!-- 상품 슬라이더 -->
                            <giftcard-slide @setBrand="setBrand"/>

                            <!-- 쿠폰 리스트 -->
                            <!-- <giftcard-detail :giftcards="giftcards" :me="me"/> -->
                            <giftcard-detail :giftcards="mobileGiftcards" :me="me"/>

                            <!-- 지류쿠폰이 있을 경우, 페이지네이션 제거 및 구분선 생성 -->
                            <div v-if="isPaperGiftcardExists">
                                <v-divider class="grey lighten-1 ma-8"/>
    
                                <!-- 지류 쿠폰 리스트 -->
                                <giftcard-detail :giftcards="paperGiftcards" :me="me"/>
                            </div>

                            <div v-if="!isPaperGiftcardExists" class="mt-30px mt-md-70px">
                                <v-pagination v-model="page" :length="pageCount" color="primary" total-visible="11" @input="search(false)"/>
                            </div>

                        </div>
                    </div>
                </v-col>
            </v-row>
            <v-dialog v-if="!me?.ci && meLoaded" v-model="dialog" max-width="500" :width="$vuetify.breakpoint ? '50%' : '90%' " scrollable>
                <v-card>
                    <a href="/mypage/profile"><v-img src="/images/giftcard-popup3.jpg"/></a>
                    <div class="popup-layer-foot" style="display: flex; background-color: #424242; padding: 10px;">
                        <v-spacer></v-spacer>
                        <v-btn text @click="close" style="color:white; font-size: 16px;">닫기</v-btn>
                    </div>
                </v-card>
            </v-dialog>
        </v-container>
    </component>
</template>

<script>
import api from '@/api'
import giftcardNavi from "@/components/client/gshop/giftcard/giftcard-navi.vue";
import giftcardDetail from "@/components/client/gshop/giftcard/giftcard-detail.vue";
import giftcardSlide from "@/components/client/gshop/giftcard/giftcard-slide.vue";

export default {
    components: { giftcardNavi, giftcardDetail, giftcardSlide },
    data() {
        return {
            categories: [],
            giftcards: [],
            me: null,
            searchValue:null,

            meLoaded: false,

            page: 1,
            limit: 16,
            pageCount: 0,

            dialog: true,

            filter: {
                _category: this.$route.query._category || null,
                _brand: this.$route.query._brand || null
            }
        };
    },
    async mounted() {
        await this.init();
    },
    created(){
        if(this.logoff) this.$router.push(`/login`);
    },
    methods: {
        async init() {
            // let { me } = await api.v1.me.profile.get();
            // this.me = me;
            // this.meLoaded = true;
            // let { categories } = await api.v1.gshop.categories.gets({ headers: { limit: 0 }, params: { depth: 0 } })
            // this.categories = categories;

            let [ { me }, { categories } ] = await Promise.all([
                api.v1.me.profile.get(),
                api.v1.gshop.categories.gets({ headers: { limit: 0 }, params: { depth: 0 } })
            ])
            this.me = me;
            this.meLoaded = true;
            this.categories = categories;
            await this.search()
        },
        async search(routable = false){
            if(routable){
                this.$router.push({
                    query: { ...this.filter, page: this.page }
                });
                return
            }

            let { summary, giftcards } = await api.v1.gshop.giftcards.gets({
                headers: {
                    skip: (this.page - 1) * this.limit,
                    limit: this.limit
                },
                params: this.filter,
            });

            // let { me } = await api.v1.me.profile.get();
            // this.me = me;

            this.giftcards = giftcards;
            this.pageCount = Math.ceil(summary.totalCount / this.limit);
        },
        async setCategory(category) {
            this.$router.push({
                query: { ...this.filter, page: this.page, _category: category?._id }
            })
            this.filter._category = category?._id
            await this.search()
        },
        async setBrand(brand) {
            this.$router.push({
                query: { ...this.filter, page: this.page, _brand: brand?._id }
            })
            this.filter._brand = brand?._id
            await this.search()
        },
        close(){
            this.dialog = false
        }
    },
    computed: {
        template() {
            return () => import(`@/templates/${this.$theme.pages.gshop}`);
        },
        accessToken(){
            return this.$store.state.accessToken;
        },
        logoff(){
            return !this.$store.state.accessToken;
        },
        paperGiftcards() {
            return this.giftcards.filter((giftcard) => giftcard?.mode === 'paper') || [];
        },
        mobileGiftcards() {
            return this.giftcards.filter((giftcard) => giftcard?.mode === 'mobile') || [];
        },
        isPaperGiftcardExists() {
            return this.paperGiftcards.length;
        }
    },
    watch: {
        dialog(){
            if(!this.me.ci && !this.dialog){
                this.$router.push('/mypage/profile')
            }
        },
        async "$route.query._brand"(){
            this.filter = { ...this.filter, _brand: this.$route.query._brand };
            await this.search(false)
        }
    }
};
</script>

<style lang="scss" scoped>
@media (min-width: 1024px) {
    .contents-area {
        padding: 60px 114px;
    }
}
</style>
